import styled, { css } from "styled-components";

const dragActive = css`
  border-color: var(--primary);
`;

const dragReject = css`
  border-color: #e57878;
`;

export const Container = styled.div`
  align-items: center;
  box-sizing: border-box;
  height: 100% auto;
  margin: 20px 0;
  margin-bottom: 10px;
  top: 0px;
  width: 100%;
`;

export const Content = styled.div`
  background: var(--background-color);
  border-radius: 4px;
  box-shadow: var(--box-shadow);
  padding: 4px;
  width: 100%;
`;

export const DropContainer = styled.div.attrs({
  className: "dropzone",
})`
  padding: 20px;
  border: 1px dashed #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: height 0.2s ease;

  ${(props) => props.isDragActive && dragActive};
  ${(props) => props.isDragReject && dragReject};
`;

const messageColors = {
  default: "var(--color)",
  error: "#e57878",
  success: "var(--primary)",
};

export const UploadMessage = styled.p`
  justify-content: center;
  align-items: center;
  color: ${(props) => messageColors[props.type || "default"]};
  display: flex;
  padding: 15px 0;
  gap: 5px;
`;
